import { AxiosInstance } from 'axios'

import {
  userApiDefaultApiFactory,
  iamDefaultApiFactory,
} from '@src/api/default-api-factories'
import {
  DefaultApiGetMoneytreeConnectedRequest,
  DefaultApiSyncMoneytreeAccessTokenRequest,
  DefaultApiGetMoneytreeStatusRequest,
  DefaultApiGetMoneytreeOauthUrlRequest,
  DefaultApiVerifyMoneytreeConnectionsRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getMoneytreeConnected = async (
  instance: AxiosInstance,
  params: DefaultApiGetMoneytreeConnectedRequest
) => {
  return await userApiDefaultApiFactory(instance).getMoneytreeConnected(params)
}

export const syncMoneytreeAccessToken = async (
  instance: AxiosInstance,
  params: DefaultApiSyncMoneytreeAccessTokenRequest
) => {
  return await userApiDefaultApiFactory(instance).syncMoneytreeAccessToken(
    params
  )
}

export const getMoneytreeStatus = async (
  instance: AxiosInstance,
  params: DefaultApiGetMoneytreeStatusRequest
) => {
  return await userApiDefaultApiFactory(instance).getMoneytreeStatus(params)
}

export const setMoneytreeJwtOnLogin = async (instance: AxiosInstance) => {
  return await iamDefaultApiFactory(instance).getJwtSso()
}

export const getMoneytreeOauthUrl = async (
  instance: AxiosInstance,
  params: DefaultApiGetMoneytreeOauthUrlRequest
) => {
  return await userApiDefaultApiFactory(instance).getMoneytreeOauthUrl(params)
}

export const verifyMoneytreeConnections = async (
  instance: AxiosInstance,
  params: DefaultApiVerifyMoneytreeConnectionsRequest
) => {
  return await userApiDefaultApiFactory(instance).verifyMoneytreeConnections(
    params
  )
}

export const getPcJwtSso = async (instance: AxiosInstance) => {
  return await iamDefaultApiFactory(instance).getPcJwtSso()
}

// Do Not Remove this line ===@import api client===
